import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { payRuleInitialsForAdd, payRuleInitialsForUpdate } from './interfaces/payRuleClass';
import {
    getAccountPayRuleDatatableAsync, resetSelectedRecordObjectInState, addPayRuleAsync, addPayRuleDetailAsync, deleteAccountPayRuleDetailIdAsync,
    updatePayRuleAsync, updatePayRuleDetailsAsync
} from './payRuleSlice';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import clsx from 'clsx';
import { KTIcon } from '../../../_metronic/helpers';
import { right } from '@popperjs/core';
import { ShowSwalForCanvas, ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import '../../../common/css/timeLive.css'


const PayRuleForm = (props: any) => {
    const { t } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(payRuleInitialsForAdd);
    const { selectedRecord, isLoading, AccountPayCodeId, payRuleDetailList } = useAppSelector((state) => state.payRule);
    const dispatch = useAppDispatch();
    const [tab, setTab] = useState('Basic');
    const [showDivWeekend, setShowDivWeekend] = useState(false);
    const [showDivHoliday, setShowDivHoliday] = useState(false);
    const [selectedOptionPayCode, setselectedOptionPayCode] = useState<{ [object: string]: any }>();
    const [payCodeArray, SetPayCodeArray] = useState<any | ''>([]);
    const defaultPayRuleDetail = [{ AccountPayRuleDetailId: 0, AccountPayCodeId: '', Hours: '' }];
    const [payRuleDetails, setpayRuleDetails] = useState(defaultPayRuleDetail);
    const AccountPayRuleDetailId = 0;
    const getPayCodeAsync = async () => {
        const response = await fetchAPI('api/v2/PayCode/ForDropDown/' + AccountPayCodeId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountPayCodeId;
            item.label = item.Name;
            delete item.AccountPayCodeId;
            delete item.Name;
        });
        SetPayCodeArray(json.Data);

    }

    useEffect(() => {

        let stateItem: any = {}

        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;

            Object.keys(payRuleInitialsForUpdate).map((item) => {

                return stateItem[item] = tempObj[0][item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
            stateItem.AllowOvertime = stateItem.AllowOvertime === "Yes" ? true : false;
            stateItem.AllowWeekendsasOvertime = stateItem.AllowWeekendsasOvertime === "Yes" ? true : false;
            stateItem.AllowHolidayasOvertime = stateItem.AllowHolidayasOvertime === "Yes" ? true : false;
            setCurrentFieldsData(stateItem);

            if (tempObj[0].AllowWeekendsasOvertime == 'Yes') {
                setShowDivWeekend(true);
            } else {
                setShowDivWeekend(false);
            }
            if (tempObj[0].AllowHolidayasOvertime == 'Yes') {
                setShowDivHoliday(true);
            } else {
                setShowDivHoliday(false);
            }
            setpayRuleDetails(tempObj);
        }
        else {
            setShowDivWeekend(false);
            setShowDivHoliday(false);
            setpayRuleDetails(defaultPayRuleDetail);
            setCurrentFieldsData(payRuleInitialsForAdd);
        }
    }, [selectedRecord])

    useEffect(() => {
        getPayCodeAsync();

    }, [])

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    const addRow = () => {
        setpayRuleDetails([...payRuleDetails, { AccountPayRuleDetailId: 0, AccountPayCodeId: '', Hours: '' }]);
    };
    const hasValues = () => {
        return payRuleDetails.some((obj: any) => obj.AccountPayCodeId !== '' && obj.Hours !== '');
    };

    const handleSubmit = (values: any) => {

        const newArray: any = payRuleDetails.filter((obj: any) => obj.AccountPayCodeId !== '' && obj.Hours !== '');
        setpayRuleDetails(newArray);

        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updatePayRuleAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    const PayRuleId = originalPromiseResult.Id
                    dispatch(updatePayRuleDetailsAsync({ newArray, PayRuleId }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Pay Rule Update Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                })
                .catch((rejectedValueOrSerializedError) => {

                })
        }
        else {
            dispatch(addPayRuleAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    const AccountPayRuleId = originalPromiseResult.Id
                    dispatch(addPayRuleDetailAsync({ newArray, AccountPayRuleId }))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "201" ?
                                ShowToast("Pay Rule Added Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                })
                .catch((rejectedValueOrSerializedError) => {
                })
        }
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }
    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    const handleChangeWeekend = (values: any) => {
        if (values.AllowWeekendsasOvertime == true) {
            setCurrentFieldsData({ ...values, 'AllowWeekendsasOvertime': false });
            setShowDivWeekend(false);
        } else {
            setCurrentFieldsData({ ...values, 'AllowWeekendsasOvertime': true });
            setShowDivWeekend(true);
        }
    };

    const handleChangeHolidays = (values: any) => {
        if (values.AllowHolidayasOvertime == true) {
            setCurrentFieldsData({ ...values, 'AllowHolidayasOvertime': false });
            setShowDivHoliday(false);
        } else {
            setCurrentFieldsData({ ...values, 'AllowHolidayasOvertime': true });
            setShowDivHoliday(true);
        }
    };

    const handleDropdownChange = (index: any, event: any) => {
        const { value } = event;
        const updatedRows = [...payRuleDetails];
        updatedRows[index] = { ...updatedRows[index], AccountPayCodeId: value };
        setpayRuleDetails(updatedRows);

    };

    const handleTextboxChange = (index: any, event: any) => {
        const updatedRows = [...payRuleDetails];
        updatedRows[index] = { ...updatedRows[index], Hours: event.target.value };
        setpayRuleDetails(updatedRows);
    };

    const deleteRow = (index: any, AccountPayRuleDetailId: any) => {

        if (AccountPayRuleDetailId > 0) {
            ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
                .then((result) => {
                    if (result) {
                        dispatch(deleteAccountPayRuleDetailIdAsync(AccountPayRuleDetailId))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                ShowToast("Deleted Successfully", 'Success', "success", "toast-top-right");
                                const updatedRows = [...payRuleDetails];
                                updatedRows.splice(index, 1);
                                setpayRuleDetails(updatedRows);
                            })
                    }
                })
                .catch((error) => {
                });
        }
        else {
            const updatedRows = [...payRuleDetails];
            updatedRows.splice(index, 1);
            setpayRuleDetails(updatedRows);
        }
    };

    const handleNumberFieldChange = (e: any, setFieldValue: any) => {

        const { value, id } = e.target;
        if (value === '') {
            setFieldValue(id, 0);
        }
        else {
            setFieldValue(id, parseInt(value));
        }
    };


    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                // onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                onSubmit={(values, actions) => {
                    if (!hasValues()) {
                        ShowSwalForCanvas('Pay Rule Detail', `Atleast one detail is required.`, 'error',);
                    } else {
                        handleSubmit(values);
                        actions.resetForm();
                    }
                }}
                validationSchema={yup.object().shape({
                    AccountPayRuleName: yup
                        .string()
                        .label('AccountPayRuleName')
                        .trim()
                        .required(t('Pay rule name is required.'))
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, setFieldValue }) => (
                    <Fragment>

                        <div className='card-body'>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className='row'>
                                        <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6" role='tablist'>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Basic' })}
                                                    onClick={() => setTab('Basic')}
                                                    role='tab'
                                                >
                                                    {t('Basic')}
                                                </a>
                                            </li>
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer`, { active: tab === 'Advance' })}
                                                    onClick={() => setTab('Advance')}
                                                    role='tab'
                                                >
                                                    {t('Advance')}
                                                </a>
                                            </li>
                                        </ul>

                                        <div className='tab-content'>
                                            <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                                <div className='row'>
                                                    <div className="col-md-12 mb-3">
                                                        <label className="fs-7 fw-normal">{t('Rule Name')}</label>
                                                        <input type="text" className="form-control fs-7 fw-normal" id='AccountPayRuleName' value={values.AccountPayRuleName} name='AccountPayRuleName'
                                                            onChange={handleChange('AccountPayRuleName')}
                                                        />
                                                        <div style={{ paddingRight: 20 }}>
                                                            {touched.AccountPayRuleName && errors.AccountPayRuleName &&
                                                                <p className='errorMsg'>{errors.AccountPayRuleName as string}</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6 mb-2">
                                                        {Object.keys(selectedRecord).length > 0 ? (
                                                            <div className="col-md-12">
                                                                <label className="fs-7 fw-normal">{t('Disabled')}</label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                    <input className="form-check-input  h-20px w-30px mt-2" type="checkbox"
                                                                        checked={values.IsDisabled} id="IsDisabled"
                                                                        onChange={handleChange('IsDisabled')}
                                                                    />
                                                                </div>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>

                                                <div>
                                                    <div style={{ textAlign: right }}>
                                                        <button className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm p-2 fs-7" onClick={(e) => { e.preventDefault(); addRow(); }}> <KTIcon iconName='plus' className='fs-3' />{t('Add Row')}</button>
                                                    </div>

                                                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                                                        <thead>
                                                            <tr className="thHeading align-middle "  >
                                                                <th style={{ width: '48%' }}>{t('Pay Code')}</th>
                                                                <th style={{ width: '48%' }}>{t('Hours')}</th>
                                                                <th style={{ width: '4%' }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {payRuleDetails.map((row: any, index: any) => (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <Select
                                                                            value={payCodeArray.find((option: any) => option.value == row.AccountPayCodeId)}
                                                                            className="basic-single"
                                                                            classNamePrefix="select"
                                                                            isSearchable={true}
                                                                            name="AccountPayCodeId"
                                                                            id="AccountPayCodeId"
                                                                            onChange={(event) => handleDropdownChange(index, event)}
                                                                            options={payCodeArray}
                                                                            styles={colourStyles}
                                                                        />
                                                                    </td>
                                                                    <td>
                                                                        <input type="number" className="form-control fs-7 fw-normal" id='Hours'
                                                                            value={row.Hours} name='Hours'
                                                                            onChange={(event) => handleTextboxChange(index, event)}
                                                                        ></input>

                                                                    </td>
                                                                    <td>
                                                                        <a className='btn btn-icon btn-bg-light btn-active-color-danger btn-sm'
                                                                            onClick={() => deleteRow(index, row.AccountPayRuleDetailId)}>
                                                                            <KTIcon iconName='trash' className='fs-3' />
                                                                        </a>

                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>

                                                </div>
                                                {/* </div>
                                            </div> */}
                                            </div>
                                            <div className={clsx('tab-pane', { active: tab === 'Advance' })}>
                                                <div className='row'>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="fs-7 fw-normal">{t('Maximum Billable Hours')}</label>
                                                        <input type="number" className="form-control fs-7 fw-normal" id='MaximumBillableHours' value={values.MaximumBillableHours} name='MaximumBillableHours'
                                                            onChange={(e) => handleNumberFieldChange(e, setFieldValue)}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="fs-7 fw-normal">{t('Allow Overtime')}</label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input  h-20px w-30px mt-2" type="checkbox"
                                                                checked={values.AllowOvertime} id="AllowOvertime"
                                                                onChange={handleChange('AllowOvertime')}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="fs-7 fw-normal">{t('Allow Weekends as Overtime')}</label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input  h-20px w-30px mt-2" type="checkbox"
                                                                checked={values.AllowWeekendsasOvertime} id="AllowWeekendsasOvertime"
                                                                onChange={() => handleChangeWeekend(values)}
                                                            />
                                                        </div>

                                                    </div>
                                                    {showDivWeekend &&
                                                        <div className="col-md-6 mb-3">
                                                            <label className="fs-7 fw-normal">{t('Weekend Overtime Rate')}</label>
                                                            <input type="number" className="form-control fs-7 fw-normal" id='WeekendOvertimeRate' value={values.WeekendOvertimeRate} name='WeekendOvertimeRate'
                                                                onChange={(e) => handleNumberFieldChange(e, setFieldValue)}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                <div className='row'>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="fs-7 fw-normal">{t('Allow Holiday as Overtime')}</label>
                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                            <input className="form-check-input  h-20px w-30px mt-2" type="checkbox"
                                                                checked={values.AllowHolidayasOvertime} id="AllowHolidayasOvertime"
                                                                onChange={() => handleChangeHolidays(values)}
                                                            />
                                                        </div>

                                                    </div>
                                                    {showDivHoliday &&
                                                        <div className="col-md-6 mb-3">
                                                            <label className="fs-7 fw-normal">{t('Holiday Overtime Rate')}</label>
                                                            <input type="number" className="form-control fs-7 fw-normal" id='HolidayOvertimeRate' value={values.HolidayOvertimeRate} name='HolidayOvertimeRate'
                                                                onChange={(e) => handleNumberFieldChange(e, setFieldValue)}
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                                {/* </div>
                                            </div> */}
                                            </div>

                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        <div className='card-footer pt-4 '>
                            <div className='d-flex flex-stack float-end'>
                                <div className='d-flex align-items-center me-2'>
                                    <button
                                        ref={closeButtonRef}
                                        type="button"
                                        className="btn btn-secondary btn-bs-btn-font-weight  me-2 btn-sm p-2 fs-7"
                                        id="kt_OffCanvas"
                                        onClick={handleCloseOnClickEvent}
                                    >
                                        {t('Cancel')}
                                    </button>

                                    <button type="button" data-kt-element='send' className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm p-2 fs-7" onClick={() => handleSubmit()} disabled={!isValid}>
                                        {Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')}
                                    </button>
                                </div>
                            </div>
                        </div>


                    </Fragment>
                )}
            </Formik>
        </>
    )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default PayRuleForm